<template>
    <v-col cols="12" xl="10" class="py-10 px-0">
        <v-row>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.group_name"
                    :label="t('pharmacy-groups::form.label.group_name')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.group_name"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <div style="width: max-content" class="pl-2 pl-md-0">
                    <b-switch
                        to-mutate="pharmacy_groups::pharmacy_group.is_registered"
                        :label="t('pharmacy-groups::form.label.is_registered')"
                        :readonly="readOnlyRules"
                        :rules="validationRules.is_registered"
                    ></b-switch>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('pharmacy-groups::form.title.address') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.address"
                    :label="t('pharmacy-groups::form.label.address')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.address"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.post_code"
                    :label="t('pharmacy-groups::form.label.post_code')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.post_code"
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('pharmacy-groups::form.title.contact_details') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.phone"
                    :label="t('pharmacy-groups::form.label.phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.phone"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.fax"
                    :label="t('pharmacy-groups::form.label.fax')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.fax"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.email"
                    :label="t('pharmacy-groups::form.label.email')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.email"
                ></b-input>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            readOnlyRules: !this.can('api.v1.pharmacy-groups.update') && this.can('api.v1.pharmacy-groups.show'),
            validationRules: {
                group_name: [(v) => !!v || t('users::validation.field.required')],
                address: [],
                post_code: [this.$root.rules.postCode],
                phone: [],
                fax: [],
                email: [],
            },
        };
    },
    computed: {
        pharmacyGroupOptions() {
            return this.$store.state.pharmacy_groups.pharmacyGroupOptions;
        },
        bloodProvidersOptions() {
            return this.$store.state.pharmacy_groups.bloodProvidersOptions;
        },
    },
};
</script>

<style></style>
